import type { TabProps } from '@mui/material';
import type { NavLinkProps } from 'react-router-dom';
import { NavLink, useLocation } from 'react-router-dom';
import type { VyPageLayoutRequiredTabsProps } from '../../../components/new-design/layout/components/VyPageLayoutTabs';
import type { HomePageTabOption } from '../home-page-consts/home-page-tabs';
import { HOME_PAGE_TAB_OPTIONS } from '../home-page-consts/home-page-tabs';

export function useHomePageTabs(): [Required<VyPageLayoutRequiredTabsProps>['tabs'], Required<VyPageLayoutRequiredTabsProps>['currentTab']] {
  const location = useLocation();

  const tabs = Object.values({
    [HOME_PAGE_TAB_OPTIONS.Overview]: {
      key: HOME_PAGE_TAB_OPTIONS.Overview,
      label: 'Overview',
      value: HOME_PAGE_TAB_OPTIONS.Overview,
      component: NavLink,
      to: `${location.pathname}/../overview`,
    },
    [HOME_PAGE_TAB_OPTIONS.DataDashboard]: {
      key: HOME_PAGE_TAB_OPTIONS.DataDashboard,
      label: 'Dashboard',
      value: HOME_PAGE_TAB_OPTIONS.DataDashboard,
      component: NavLink,
      to: `${location.pathname}/../dashboard`,
    },
  } satisfies Record<HomePageTabOption, TabProps<typeof NavLink, NavLinkProps>>);

  const currentTab = location.pathname.split('/').pop() as HomePageTabOption;

  return [tabs, currentTab];
}